<template>
  <div>
    <button v-on="$listeners" class="button" :class="buttonClass" v-bind="$attrs">
        <slot/>
    </button>
  </div>
</template>

<script>
export default {
    inheritAttrs: false,
    name: 'BaseButton',
    props: {
        buttonClass: {
            type: String
        }
    }

}
</script>

<style scoped>
.button {
    padding: 11px 24px;
    border-radius: 6px;
    letter-spacing: 0.005em;
    font-size: 14px;
    line-height: 150%;
    font-weight: 600;
    width: 100%;
}

.withdrawButton {
    margin: 12px 0px;
    background: #002FA7;
    color: #FFFFFF;
    width: 70%;
}

button:disabled {
    background-color: grey;
}
</style>
